// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.titleStyle[data-v-3f0e786d] {\n  font-size: 18px;\n  font-weight: bold;\n}\n.app-container[data-v-3f0e786d] .el-pagination__total {\n  margin-top: 4px;\n}\n", ""]);
// Exports
module.exports = exports;
